"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFWrap = exports.PreviewWrap = exports.InfoWrap = exports.MessageTitle = exports.CompanyNameSpan = exports.CompanyNameLink = exports.OfferTitle = exports.OfferTitleLink = exports.FullWidthDiv = exports.ApplicationListWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const elements_1 = require("@src/components/elements");
exports.ApplicationListWrapper = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-direction: column;
	margin: 2rem 0 0 0;
	padding: 2rem 0 0 0;
	border-top: 1px solid ${props => props.theme.color.gray4};
	&:first-child {
		margin-top: 0;
		padding-top: 0;
		border-top: 0;
	}
`;
exports.FullWidthDiv = styled_components_1.default.div `
	width: 100%;
`;
exports.OfferTitleLink = (0, styled_components_1.default)(elements_1.Link) `
	color: ${props => props.theme.color.brand1};
	font-size: 1.125rem;
	font-weight: bold;
`;
exports.OfferTitle = styled_components_1.default.div `
	color: ${props => props.theme.color.black};
	font-size: 1.125rem;
	font-weight: bold;
`;
exports.CompanyNameLink = (0, styled_components_1.default)(elements_1.Link) `
	color: ${props => props.theme.color.gray6};
	font-size: 0.9rem;
`;
exports.CompanyNameSpan = styled_components_1.default.span `
	color: ${props => props.theme.color.gray6};
	font-size: 0.9rem;
`;
exports.MessageTitle = styled_components_1.default.div `
	font-size: 0.9rem;
	color: ${props => props.theme.color.black};
	margin-top: 1rem;
	font-weight: bold;
`;
exports.InfoWrap = styled_components_1.default.div `
	display: flex;
	margin-top: 3rem;
	justify-content: space-between;
	${(0, styled_breakpoints_1.down)('md')} {
		flex-direction: column;
	}
`;
exports.PreviewWrap = styled_components_1.default.div `
	display: flex;
`;
exports.PDFWrap = styled_components_1.default.div `
	margin: 0 0 0 1rem;
	${(0, styled_breakpoints_1.down)('md')} {
		padding: 1rem 0 0 0;
		margin: 0 1rem 0 0;
	}
`;
